/* Luxuntique 2026 — Find my size
   A foot profile is saved once (localStorage) and re-applied to every product,
   using that product's own brand chart from shop.metafields.custom.size_guides.
   Method: reference pair (most reliable) or foot length + 0.5 cm allowance,
   then width (New Balance official width chart), instep, preference and the
   model's fit (product.metafields.custom.fit_length / fit_width, optional). */
(function () {
  if (window.LuxFit) return;

  var STORE = 'lux_fit_v1';
  var ALLOW = 0.5;
  // New Balance width chart, cm: [EU, B narrow, D standard, 2E wide, 4E extra wide]
  var WT = [[38.5,9.3,9.7,10.1,10.4],[39.5,9.5,9.8,10.2,10.5],[40,9.6,9.9,10.3,10.6],[40.5,9.7,10,10.4,10.7],[41.5,9.8,10.1,10.5,10.8],[42,9.9,10.2,10.6,10.9],[42.5,10,10.4,10.7,11],[43,10.1,10.5,10.8,11.1],[44,10.2,10.6,10.9,11.3],[44.5,10.3,10.7,11,11.4],[45,10.4,10.8,11.1,11.5],[45.5,10.5,10.9,11.3,11.6],[46.5,10.6,11,11.4,11.7],[47,10.7,11.1,11.5,11.8]];
  // Generic length reference (New Balance men's): [UK, EU, CM]
  var LEN = [[3.5,36,22],[4,37,22.5],[4.5,37.5,23],[5,38,23.5],[5.5,38.5,24],[6,39.5,24.5],[6.5,40,25],[7,40.5,25.5],[7.5,41.5,26],[8,42,26.5],[8.5,42.5,27],[9,43,27.5],[9.5,44,28],[10,44.5,28.5],[10.5,45,29],[11,45.5,29.5],[11.5,46.5,30],[12,47,30.5],[12.5,47.5,31]];
  var NAMES = { narrow: 'Narrow', regular: 'Regular', wide: 'Wide', xwide: 'Extra wide' };

  function num(v) {
    if (v == null) return NaN;
    var m = String(v).trim().match(/^(\d+(?:\.\d+)?)(?:\s+(\d)\/(\d))?/);
    if (!m) return NaN;
    var n = parseFloat(m[1]);
    if (m[2]) n += parseInt(m[2], 10) / parseInt(m[3], 10);
    return n;
  }
  function col(chart, p) {
    if (!chart || !chart.headers) return -1;
    for (var i = 0; i < chart.headers.length; i++) {
      if (String(chart.headers[i]).toUpperCase().indexOf(p) === 0) return i;
    }
    return -1;
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }
  function load() { try { return JSON.parse(localStorage.getItem(STORE)) || null; } catch (e) { return null; } }
  /* Tell the page the saved foot profile changed (the product page swaps Find my size for Your size) */
  function changed() { document.dispatchEvent(new CustomEvent('lux:fit-change')); }
  function save(p) { try { localStorage.setItem(STORE, JSON.stringify(p)); } catch (e) {} changed(); }
  function clear() { try { localStorage.removeItem(STORE); } catch (e) {} changed(); }
  function f1(n) { return (Math.round(n * 10) / 10).toFixed(1); }
  function lenRowForCm(cm) {
    for (var i = 0; i < LEN.length; i++) if (LEN[i][2] >= cm - 0.001) return LEN[i];
    return LEN[LEN.length - 1];
  }
  function lenRowForUK(uk) {
    for (var i = 0; i < LEN.length; i++) if (LEN[i][0] >= uk - 0.001) return LEN[i];
    return LEN[LEN.length - 1];
  }
  function widthRow(eu) {
    var best = WT[0];
    WT.forEach(function (r) { if (Math.abs(r[0] - eu) < Math.abs(best[0] - eu)) best = r; });
    return best;
  }
  function thresholds(baseUK) {
    var r = widthRow(baseUK != null ? lenRowForUK(baseUK)[1] : 42);
    return { eu: r[0], d: r[2], t1: (r[1] + r[2]) / 2, t2: (r[2] + r[3]) / 2, t3: (r[3] + r[4]) / 2 };
  }
  function classify(v, t) { return v < t.t1 ? 'narrow' : v < t.t2 ? 'regular' : v < t.t3 ? 'wide' : 'xwide'; }

  /* Base UK size from the saved profile (before width, instep, preference) */
  function baseUK(p) {
    if (!p) return null;
    if (p.route === 'ref' && p.refUK > 0) {
      return p.refUK + (p.fit === 'tight' ? 0.5 : p.fit === 'loose' ? -0.5 : 0);
    }
    if (p.route === 'measure' && p.cm > 0) return lenRowForCm(p.cm + ALLOW)[0];
    return null;
  }

  /* Recommendation for one product. model: { chart, fitLength: 'small'|'true'|'large', fitWidth: 'narrow'|'standard'|'wide' } */
  function recommend(p, model) {
    var b = baseUK(p);
    if (b == null) return null;
    var reasons = [];
    if (p.route === 'ref') {
      reasons.push('Your ' + p.refBrand + ' ' + p.refLabel + (p.fit === 'perfect' ? ' fits well' : p.fit === 'tight' ? ' feels tight → up ½ size' : ' feels loose → down ½ size'));
    } else {
      reasons.push('Foot length ' + p.cm + ' cm + ' + ALLOW + ' cm allowance for measuring at home → UK ' + b);
    }
    var isWide = p.width === 'wide' || p.width === 'xwide';
    var mw = (model && model.fitWidth) || 'standard';
    var w = 0;
    if (p.route === 'measure') {
      w = { narrow: 0, regular: 0, wide: 0.5, xwide: 1 }[p.width] || 0;
      if (mw === 'wide') w = Math.max(0, w - 0.5);
      if (mw === 'narrow' && isWide) w += 0.5;
    } else if (mw === 'narrow' && isWide) {
      w = 0.5;
    }
    var wTxt = p.wcm > 0 ? ' (' + f1(p.wcm) + ' cm)' : '';
    if (w > 0) reasons.push((p.width === 'xwide' ? 'Extra wide feet' : 'Wide feet') + wTxt + (mw === 'narrow' ? ' and this model runs narrow' : '') + ' → up ' + (w === 0.5 ? '½ size' : '1 size'));
    else if (isWide && p.route === 'ref') reasons.push('Wide feet are already reflected in the pair you wear');
    else if (isWide) reasons.push('Wide feet, and this model has a wide fit → no change');
    else if (p.width) reasons.push(NAMES[p.width] + ' width' + wTxt + ' → no change');

    var ins = 0;
    if (p.instep && p.route === 'measure') { ins = 0.5; reasons.push('High instep → up ½ size'); }
    var pref = p.pref === 'roomy' ? 0.5 : 0;
    if (pref) reasons.push('You like a little room → up ½ size');
    var mf = model && model.fitLength === 'small' ? 0.5 : model && model.fitLength === 'large' ? -0.5 : 0;
    if (mf > 0) reasons.push('This model runs small → up ½ size');
    else if (mf < 0) reasons.push('This model runs large → down ½ size');

    var trueUK = b + w + ins;
    var recUK = trueUK + pref + mf;

    var chart = model && model.chart;
    var cU = col(chart, 'UK'), cE = col(chart, 'EU'), cS = col(chart, 'US');
    var rec = null, tru = null;
    if (chart && cU >= 0) {
      var rows = chart.rows || [];
      var pick = function (uk) {
        var best = null;
        rows.forEach(function (r) {
          var u = num(r[cU]);
          if (u >= uk - 0.001 && (best === null || u < num(best[cU]))) best = r;
        });
        return best || rows[rows.length - 1];
      };
      var rr = pick(recUK), tr = pick(trueUK);
      rec = { uk: rr[cU], eu: cE >= 0 ? rr[cE] : '', us: cS >= 0 ? rr[cS] : '' };
      tru = { uk: tr[cU], eu: cE >= 0 ? tr[cE] : '' };
    } else {
      var lr = lenRowForUK(recUK), lt = lenRowForUK(trueUK);
      rec = { uk: String(lr[0]), eu: String(lr[1]), us: '' };
      tru = { uk: String(lt[0]), eu: String(lt[1]) };
    }
    return { rec: rec, tru: tru, reasons: reasons, confident: p.route === 'ref' };
  }

  /* ---------------- UI ---------------- */
  function Finder(root) {
    this.root = root;
    try { this.data = JSON.parse(root.querySelector('.lux-sf__data').textContent); } catch (e) { this.data = {}; }
    this.guides = [];
    var g = this.data.guides || {};
    for (var k in g) {
      if (Object.prototype.hasOwnProperty.call(g, k) && k.indexOf('|footwear') > 0 && g[k] && g[k].charts && g[k].charts.length) this.guides.push(g[k]);
    }
    this.guides.sort(function (a, b) { return String(a.brand).localeCompare(String(b.brand)); });
    this.model = { chart: this.data.chart || null, fitLength: this.data.fitLength || 'true', fitWidth: this.data.fitWidth || 'standard' };
    var saved = load();
    this.s = { step: saved ? 4 : 0, p: saved || {}, brand: 0, g: 0, sys: 'UK' };
    var self = this;
    var own = this.guides.findIndex(function (x) { return String(x.brand).toLowerCase() === String(self.data.brand || '').toLowerCase(); });
    if (own >= 0) this.s.brand = own;
    root.addEventListener('click', function (e) { self.onClick(e); });
    root.addEventListener('input', function (e) { self.onInput(e); });
    this.render();
  }

  Finder.prototype.chart = function () {
    var b = this.guides[this.s.brand];
    if (!b) return null;
    return b.charts[Math.min(this.s.g, b.charts.length - 1)];
  };

  Finder.prototype.canNext = function () {
    var s = this.s, p = s.p;
    if (s.step === 1) return p.route === 'ref' ? p.refUK > 0 && !!p.fit : p.cm >= 15 && p.cm <= 35;
    if (s.step === 2) return !!p.width;
    if (s.step === 3) return !!p.pref;
    return false;
  };

  Finder.prototype.onInput = function (e) {
    var t = e.target, p = this.s.p;
    if (t.matches('[data-in="cm"]')) {
      p.cm = parseFloat(t.value) || 0;
      this.syncNav();
    } else if (t.matches('[data-in="wcm"]')) {
      p.wcm = parseFloat(t.value) || 0;
      if (p.wcm > 0) p.width = classify(p.wcm, thresholds(baseUK(p)));
      this.renderWidthState();
      this.syncNav();
    }
  };

  Finder.prototype.onClick = function (e) {
    var el = e.target.closest('[data-act]');
    if (!el || !this.root.contains(el)) return;
    var a = el.dataset.act, v = el.dataset.v, s = this.s, p = s.p;
    if (a === 'route') { p.route = v; s.step = 1; }
    else if (a === 'brand') { s.brand = +v; s.g = 0; p.refUK = 0; }
    else if (a === 'gender') { s.g = +v; p.refUK = 0; }
    else if (a === 'sys') { s.sys = v; }
    else if (a === 'ref') {
      var c = this.chart(), row = c.rows[+v], cU = col(c, 'UK'), sc = col(c, s.sys);
      p.refUK = cU >= 0 ? num(row[cU]) : NaN;
      if (!(p.refUK > 0)) { var ce = col(c, 'EU'); var eu = num(row[ce]); var near = LEN[0]; LEN.forEach(function (r) { if (Math.abs(r[1] - eu) < Math.abs(near[1] - eu)) near = r; }); p.refUK = near[0]; }
      p.refRow = +v;
      p.refBrand = this.guides[s.brand].brand;
      p.refLabel = s.sys + ' ' + row[sc >= 0 ? sc : (cU >= 0 ? cU : 0)];
    }
    else if (a === 'fit') { p.fit = v; }
    else if (a === 'width') { p.width = v; }
    else if (a === 'instep') { p.instep = !p.instep; }
    else if (a === 'pref') { p.pref = v; }
    else if (a === 'next') { if (!this.canNext()) return; s.step += 1; if (s.step === 4) save(p); }
    else if (a === 'back') { s.step = Math.max(0, s.step - 1); }
    else if (a === 'restart') { clear(); s.p = {}; s.step = 0; }
    else if (a === 'use') {
      var r = recommend(p, this.model);
      if (r) document.dispatchEvent(new CustomEvent('lux:size-apply', { detail: { uk: r.rec.uk, eu: r.rec.eu } }));
      var overlay = this.root.closest('.sg-overlay');
      if (overlay) { var x = overlay.querySelector('.sg-close'); if (x) x.click(); }
      return;
    }
    else return;
    this.render();
  };

  Finder.prototype.syncNav = function () {
    var n = this.root.querySelector('[data-act="next"]');
    if (n) n.disabled = !this.canNext();
  };

  Finder.prototype.renderWidthState = function () {
    var p = this.s.p, hint = this.root.querySelector('.lux-sf__hint');
    var t = thresholds(baseUK(p));
    if (hint) hint.textContent = p.wcm > 0
      ? f1(p.wcm) + ' cm at EU ' + t.eu + ' is ' + NAMES[classify(p.wcm, t)] + ' on New Balance’s width chart (standard is ' + f1(t.d) + ' cm). You can still change it below.'
      : 'Type your width and we’ll pick the right option, or choose one below.';
    this.root.querySelectorAll('[data-act="width"]').forEach(function (b) {
      b.setAttribute('aria-pressed', b.dataset.v === p.width ? 'true' : 'false');
    });
  };

  Finder.prototype.render = function () {
    var s = this.s, p = s.p, h = '';
    var prog = '<div class="lux-sf__prog" aria-hidden="true">' + [1, 2, 3, 4].map(function (i) { return '<span class="' + (s.step >= i ? 'on' : '') + '"></span>'; }).join('') + '</div>';
    var chip = function (act, v, label, on, sub) {
      return '<button type="button" class="lux-sf__chip" data-act="' + act + '" data-v="' + esc(v) + '" aria-pressed="' + (on ? 'true' : 'false') + '">' + esc(label) + (sub ? '<small>' + esc(sub) + '</small>' : '') + '</button>';
    };

    if (s.step === 0) {
      h += '<p class="lux-sf__eyebrow">Find my size · 30 seconds</p>';
      h += '<h3 class="lux-sf__title">How would you like to start?</h3>';
      h += '<div class="lux-sf__routes">';
      h += '<button type="button" class="lux-sf__route" data-act="route" data-v="ref"><span class="lux-sf__tag">Most accurate</span><strong>I know my size in another brand</strong><span>Pick a pair you already own and how it fits.</span></button>';
      h += '<button type="button" class="lux-sf__route" data-act="route" data-v="measure"><span class="lux-sf__tag">2 minutes</span><strong>I’ll measure my foot</strong><span>A ruler, a sheet of paper and a wall.</span></button>';
      h += '</div>';
    } else if (s.step === 1 && p.route === 'ref') {
      var c = this.chart(), self = this;
      h += prog + '<p class="lux-sf__eyebrow">Step 1 of 4</p><h3 class="lux-sf__title">A pair you own and love</h3>';
      h += '<p class="lux-sf__label">Brand</p><div class="lux-sf__chips lux-sf__chips--wrap">' + this.guides.map(function (g, i) { return chip('brand', i, g.brand, i === s.brand); }).join('') + '</div>';
      var gb = this.guides[s.brand];
      if (gb && gb.charts.length > 1) h += '<div class="lux-sf__chips lux-sf__chips--wrap">' + gb.charts.map(function (ch, i) { return chip('gender', i, ch.label, i === Math.min(s.g, gb.charts.length - 1)); }).join('') + '</div>';
      if (c) {
        var sysList = ['UK', 'EU', 'US'].filter(function (y) { return col(c, y) >= 0; });
        if (sysList.indexOf(s.sys) < 0) s.sys = sysList[0] || 'UK';
        var sc = col(c, s.sys);
        h += '<div class="lux-sf__row"><p class="lux-sf__label">Your size</p><div class="lux-sf__seg">' + sysList.map(function (y) { return chip('sys', y, y, y === s.sys); }).join('') + '</div></div>';
        h += '<div class="lux-sf__grid">' + c.rows.map(function (r, i) { return chip('ref', i, r[sc], p.refRow === i && p.refBrand === self.guides[s.brand].brand); }).join('') + '</div>';
      }
      h += '<p class="lux-sf__label">How does it fit?</p><div class="lux-sf__chips">' + [['tight', 'Tight'], ['perfect', 'Perfect'], ['loose', 'Loose']].map(function (f) { return chip('fit', f[0], f[1], p.fit === f[0]); }).join('') + '</div>';
    } else if (s.step === 1) {
      h += prog + '<p class="lux-sf__eyebrow">Step 1 of 4</p><h3 class="lux-sf__title">Your foot length</h3>';
      h += '<p class="lux-sf__text">Stand on paper with your heel against a wall. Mark your longest toe and measure in cm. Measure both feet in the evening and use the longer one.</p>';
      h += '<label class="lux-sf__field"><input type="number" inputmode="decimal" step="0.1" min="15" max="35" placeholder="e.g. 26.0" data-in="cm" value="' + (p.cm || '') + '"><span>cm</span></label>';
    } else if (s.step === 2) {
      var t = thresholds(baseUK(p));
      h += prog + '<p class="lux-sf__eyebrow">Step 2 of 4</p><h3 class="lux-sf__title">Your foot width</h3>';
      h += '<p class="lux-sf__text">Measure across the widest part of your foot, at the ball, while standing.</p>';
      h += '<label class="lux-sf__field"><input type="number" inputmode="decimal" step="0.1" min="6" max="15" placeholder="Optional, e.g. 10.0" data-in="wcm" value="' + (p.wcm || '') + '"><span>cm</span></label>';
      h += '<p class="lux-sf__hint"></p>';
      var opts = [['narrow', 'Narrow', 'under ' + f1(t.t1) + ' cm', 'Shoes feel loose at the sides'], ['regular', 'Regular', f1(t.t1) + '–' + f1(t.t2) + ' cm', 'Most shoes fit comfortably'], ['wide', 'Wide', f1(t.t2) + '–' + f1(t.t3) + ' cm', 'Shoes often pinch at the sides'], ['xwide', 'Extra wide', f1(t.t3) + ' cm +', 'You usually size up or buy wide']];
      h += '<div class="lux-sf__options">' + opts.map(function (o) { return '<button type="button" class="lux-sf__opt" data-act="width" data-v="' + o[0] + '" aria-pressed="' + (p.width === o[0] ? 'true' : 'false') + '"><strong>' + o[1] + '</strong><span class="lux-sf__mono">' + o[2] + '</span><span>' + o[3] + '</span></button>'; }).join('') + '</div>';
      h += '<button type="button" class="lux-sf__toggle" data-act="instep" aria-pressed="' + (p.instep ? 'true' : 'false') + '"><span class="lux-sf__switch" aria-hidden="true"></span>High instep: the top of my foot often feels pressed by laces</button>';
    } else if (s.step === 3) {
      h += prog + '<p class="lux-sf__eyebrow">Step 3 of 4</p><h3 class="lux-sf__title">How do you like them to fit?</h3>';
      h += '<div class="lux-sf__options lux-sf__options--2">' + [['true', 'True to size', 'Snug and secure, how most sneakers are meant to fit'], ['roomy', 'A little roomy', 'Space for thicker socks or all-day comfort']].map(function (o) { return '<button type="button" class="lux-sf__opt" data-act="pref" data-v="' + o[0] + '" aria-pressed="' + (p.pref === o[0] ? 'true' : 'false') + '"><strong>' + o[1] + '</strong><span>' + o[2] + '</span></button>'; }).join('') + '</div>';
    } else {
      var r = recommend(p, this.model);
      if (!r) { s.step = 0; return this.render(); }
      h += '<p class="lux-sf__eyebrow">Your size for this pair</p>';
      h += '<div class="lux-sf__result"><div class="lux-sf__big">UK ' + esc(r.rec.uk) + '</div><div class="lux-sf__mono">' + (r.rec.eu ? 'EU ' + esc(r.rec.eu) : '') + (r.rec.us ? '  ·  US ' + esc(r.rec.us) : '') + '</div></div>';
      h += '<p class="lux-sf__text">Your true size: <strong>UK ' + esc(r.tru.uk) + (r.tru.eu ? ' · EU ' + esc(r.tru.eu) : '') + '</strong></p>';
      h += '<ul class="lux-sf__reasons">' + r.reasons.map(function (x) { return '<li>' + esc(x) + '</li>'; }).join('') + '</ul>';
      h += '<p class="lux-sf__note"><strong>' + (r.confident ? 'High confidence.' : 'Good estimate.') + '</strong> ' + (r.confident ? 'Based on a pair you already wear, the most reliable guide.' : 'Home measurements often read a little short. If a pair you own fits well, try “I know my size” for a sharper result.') + '</p>';
      h += '<button type="button" class="lux-sf__primary" data-act="use">Use UK ' + esc(r.rec.uk) + ' for this pair</button>';
      h += '<button type="button" class="lux-sf__link" data-act="restart">Start again</button>';
    }

    if (s.step > 0 && s.step < 4) {
      h += '<div class="lux-sf__nav"><button type="button" class="lux-sf__link" data-act="back">Back</button><button type="button" class="lux-sf__primary" data-act="next">' + (s.step === 3 ? 'See my size' : 'Next') + '</button></div>';
    }
    this.root.querySelector('.lux-sf__body').innerHTML = h;
    if (s.step === 2) this.renderWidthState();
    this.syncNav();
  };

  /* Short summary for the product page line */
  function summary(model) {
    var r = recommend(load(), model);
    return r ? { uk: r.rec.uk, eu: r.rec.eu } : null;
  }

  /* Apply a size to the page: pre-order chips or the variant picker */
  document.addEventListener('lux:size-apply', function (e) {
    var eu = num(e.detail && e.detail.eu);
    if (isNaN(eu)) return;
    // Adidas/Salomon list 43 1/3 as 43 and 42 2/3 as 42.5 in variants
    var near = function (x) { var n = num(x); return !isNaN(n) && (Math.abs(n - eu) < 0.2 || Math.floor(eu * 2) / 2 === n); };
    var chipEl = Array.prototype.find.call(document.querySelectorAll('.lx-po__size'), function (b) { return near(b.dataset.eu); });
    if (chipEl) { chipEl.click(); chipEl.scrollIntoView({ block: 'center', behavior: 'smooth' }); return; }
    var radio = Array.prototype.find.call(document.querySelectorAll('input[type="radio"]'), function (i) { return /size/i.test(i.name || '') && near(i.value); });
    if (radio) { radio.click(); radio.dispatchEvent(new Event('change', { bubbles: true })); }
  });

  window.LuxFit = { Finder: Finder, recommend: recommend, summary: summary, load: load, num: num };

  function boot() {
    document.querySelectorAll('.lux-sf:not([data-ready])').forEach(function (el) {
      el.setAttribute('data-ready', '1');
      el.luxFinder = new Finder(el);
    });
    document.querySelectorAll('.lux-sg__mine:not([data-ready])').forEach(function (el) {
      el.setAttribute('data-ready', '1');
      var f = document.getElementById(el.dataset.finder);
      var sum = f && f.luxFinder ? summary(f.luxFinder.model) : null;
      if (sum) {
        el.querySelector('.lux-sg__mine-size').textContent = 'UK ' + sum.uk + (sum.eu ? ' · EU ' + sum.eu : '');
        el.hidden = false;
      }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  window.LuxFit.boot = boot;
})();
